import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const Row = ({ k, v, id }) => (
  <div className="flex gap-3 text-sm py-1 border-b border-slate-700"><span className="w-56 shrink-0 text-slate-400">{k}</span><span className="font-mono break-all text-slate-100" data-testid={id}>{String(v ?? "—")}</span></div>
);

export default function MerchantRegistration() {
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  const [params] = useSearchParams();
  useEffect(() => { api.get("/merchant-registration/status").then((r) => setS(r.data)).catch((e) => setErr(e.response?.data?.detail || "Failed to load")); }, []);
  const start = async (mode) => {
    try { const { data } = await api.get("/merchant-registration/start", { params: { mode } }); window.location.assign(data.authorization_url); }
    catch (e) { setErr(e.response?.data?.detail || "Could not start"); }
  };
  if (err) return <div className="p-6 text-sm text-red-600" data-testid="merchant-reg-error">{err}</div>;
  if (!s) return <div className="p-6 text-sm text-slate-500">Loading…</div>;
  const last = s.last_result;
  return (
    <div className="p-6 max-w-3xl space-y-5" data-testid="merchant-reg-page">
      <h1 className="text-2xl font-bold text-slate-100">Google Merchant API developer registration</h1>
      <p className="text-sm text-slate-400">One-time step. Sign in with a Google account that is an Admin of the developer Merchant Center account. No Google tokens are stored and no products or settings are changed.</p>
      {params.get("result") && <div className="text-sm rounded bg-slate-800 text-slate-100 p-3" data-testid="merchant-reg-result">Result: {params.get("result")}</div>}
      <div>
        <Row k="Project ID" v={s.project_id} id="mr-project-id" />
        <Row k="Project number" v={s.project_number} id="mr-project-number" />
        <Row k="Client ID project number" v={s.checks.client_id_project_number} id="mr-client-prefix" />
        <Row k="Merchant Center account" v={s.account_id} id="mr-account" />
        <Row k="Technical contact" v={s.developer_email} id="mr-contact" />
        <Row k="Redirect URI" v={s.redirect_uri} id="mr-redirect" />
        {Object.entries(s.checks).filter(([k]) => k !== "client_id_project_number").map(([k, v]) => <Row key={k} k={k.replaceAll("_", " ")} v={v ? "PASS" : "FAIL"} id={`mr-check-${k}`} />)}
      </div>
      <div className="flex gap-3">
        <Button onClick={() => start("verify")} disabled={!s.ready} data-testid="merchant-reg-verify-btn">Sign in with Google and verify only</Button>
        <Button variant="outline" onClick={() => start("register")} disabled={!s.ready} data-testid="merchant-reg-start-btn">Register again</Button>
      </div>
      <p className="text-xs text-slate-400">Verify only reads getDeveloperRegistration and getAccountForGcpRegistration; it never calls registerGcp.</p>
      {last && (
        <div className="space-y-2" data-testid="merchant-reg-last">
          <h2 className="font-semibold text-slate-100">Last attempt ({last.mode || "register"}): {last.at} · verified {String(last.verified)}</h2>
          <Row k="Minutes since registration" v={last.minutes_since_registration} id="mr-minutes" />
          <Row k="GCP registered account" v={last.gcp_registered_account} id="mr-gcp-account" />
          <Row k="Registered GCP IDs" v={(last.registered_gcp_ids || []).join(", ")} id="mr-gcp-ids" />
          <pre className="text-xs bg-slate-900 text-slate-200 p-3 rounded overflow-auto" data-testid="merchant-reg-steps">{JSON.stringify(last.steps, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
